import Dropdown from "components/Dropdown";
import {ArrowUpDown, ChevronDown} from "lucide-react";
import {FC, useEffect, useState} from "react";
import {useSearchParams} from "react-router-dom";

const Ordering: FC = () => {
  const [sp, setSp] = useSearchParams();
  const [ordering, setOrdering] = useState(sp.get("ordering") || "");

  useEffect(() => {
    setSp((old) => {
      if (ordering) {
        old.set("ordering", ordering);
      } else {
        old.delete("ordering");
      }

      return old;
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ordering]);

  const triggerContent = (_open: boolean) => (
    <span className="flex items-center gap-1.5 text-xs font-semibold text-brand-muted">
      <ArrowUpDown className="w-3.5 h-3.5" />
      Sort by
      <ChevronDown className="w-3.5 h-3.5" />
    </span>
  );

  const triggerClassName = (open: boolean) =>
    [
      "flex items-center gap-1.5 px-3 py-2 rounded-xl border border-brand-border hover:shadow-sm transition-all",
      open ? "bg-[#FEF3EA]" : "bg-white",
    ].join(" ");

  return (
    <Dropdown value="Sort by" triggerContent={triggerContent} triggerClassName={triggerClassName}>
      <div className="flex flex-col bg-white rounded-xl border border-brand-border shadow-lg p-3 z-[15] gap-1 mt-2 min-w-[180px]">
        {(
          [
            {key: "", label: "Top Candidate First"},
            {key: "knowledge", label: "Knowledge High First"},
            {key: "consistency", label: "Consistency High First"},
            {key: "speed", label: "Speed High First"},
          ] as const
        ).map(({key, label}) => (
          <button
            key={key}
            onClick={() => setOrdering(key)}
            className="px-3 py-2 rounded-lg bg-white hover:shadow-sm transition-all
              text-brand-muted text-xs flex items-center gap-2 group"
          >
            <div className="w-3 h-3 rounded-full border-2 border-brand-border flex items-center justify-center flex-shrink-0">
              <div
                className={
                  [
                    "w-1.5 h-1.5 rounded-full transition-all",
                    ordering === key ? "bg-brand-orange" : "bg-transparent group-hover:bg-brand-border",
                  ].asClass
                }
              />
            </div>
            <span>{label}</span>
          </button>
        ))}
      </div>
    </Dropdown>
  );
};

export default Ordering;
